import React from 'react';
import Calculator from './Calculator';
import './App.css'

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;